// extracted by mini-css-extract-plugin
module.exports = {"logo":"Unsupported_logo__3A_xp","container":"Unsupported_container__2QK43","upload_btn":"Unsupported_upload_btn__1PX1V","warning":"Unsupported_warning__3rvvQ"};